module.exports = __webpack_public_path__ + "static/media/btn_moon_active.b2c154f3.png";